import type { NeighborFlavor } from "@/utils/types/flavor";

export const NEIGHBOR_FLAVORS: NeighborFlavor[] = [
  { id: "n1",  name: "Strawberry Jam",       family: "fruity", x: 0.62, y: 0.38 },
  { id: "n2",  name: "Wild Strawberry",      family: "fruity", x: 0.70, y: 0.44 },
  { id: "n3",  name: "Strawberry Milkshake", family: "dairy",  x: 0.60, y: 0.52 },
  { id: "n4",  name: "Raspberry Coulis",     family: "fruity", x: 0.74, y: 0.30 },
  { id: "n5",  name: "Peach Melba",          family: "fruity", x: 0.80, y: 0.48 },
  { id: "n6",  name: "Vanilla Custard",      family: "sweet",  x: 0.52, y: 0.68 },
  { id: "n7",  name: "Clotted Cream",        family: "dairy",  x: 0.46, y: 0.62 },
  { id: "n8",  name: "Rose Petal",           family: "floral", x: 0.82, y: 0.20 },
  { id: "n9",  name: "Green Apple",          family: "green",  x: 0.84, y: 0.62 },
  { id: "n10", name: "Elderflower Cordial",  family: "floral", x: 0.88, y: 0.34 },
  { id: "n11", name: "Brown Butter",         family: "roast",  x: 0.30, y: 0.72 },
  { id: "n12", name: "Hojicha Latte",        family: "roast",  x: 0.22, y: 0.62 },
  { id: "n13", name: "Yuzu Sorbet",          family: "fruity", x: 0.90, y: 0.54 },
  { id: "n14", name: "Honeyed Oat",          family: "sweet",  x: 0.38, y: 0.78 },
  { id: "n15", name: "Shiso Leaf",           family: "green",  x: 0.92, y: 0.72 },
  { id: "n16", name: "Lychee",               family: "fruity", x: 0.78, y: 0.24 },
  { id: "n17", name: "Toasted Almond",       family: "roast",  x: 0.28, y: 0.82 },
  { id: "n18", name: "Osmanthus Tea",        family: "floral", x: 0.86, y: 0.28 },
  { id: "n19", name: "Sour Cherry",          family: "fruity", x: 0.70, y: 0.22 },
  { id: "n20", name: "Crème Brûlée",         family: "sweet",  x: 0.42, y: 0.70 },
];

export const SCATTER_POINTS = {
  target:  { x: 0.72, y: 0.42 },
  current: { x: 0.54, y: 0.56 },
};
